













import Vue from 'vue';

export default Vue.extend({
  name: 'FilterSummary',
  props: {
    title: String,
    values: Array as () => Array<string | number>,
    labels: {
      type: Object as () => { [key: string]: string },
      required: false,
      default: () => {
        return {};
      },
    },
    maxLength: {
      type: Number,
      required: false,
      default: 30,
    },
  },
  computed: {
    detail(): [string, string[]] {
      const displayValues = [];
      let displayLength = 0;
      const labels = this.values.map((v) => {
        const stringVal = v.toString();
        if (stringVal in this.labels) {
          return this.labels[stringVal];
        } else {
          return stringVal;
        }
      });
      while (labels.length > 0) {
        const displayVal = labels[0];
        if (displayLength > 0 && displayLength + displayVal.length > this.maxLength) {
          // We'd overflow, bomb out now
          return [displayValues.join(', '), labels];
        }
        labels.shift();
        displayValues.push(displayVal);
        displayLength += displayVal.length;
      }
      // We can fit them all in, w00t;
      return [displayValues.join(', '), []];
    },
  },
});
